var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.8333C15.5228 18.8333 20 15.1024 20 10.5C20 5.89758 15.5228 2.16663 10 2.16663C4.47715 2.16663 0 5.89758 0 10.5C0 15.1024 4.47715 18.8333 10 18.8333Z",
    fill: "#9DE5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15491 17.5867C1.92767 17.0321 2.47742 16.38 2.83147 15.4399L4.76547 17.0884C3.87155 18.0363 2.79446 18.6571 1.51057 18.8293C1.29826 18.8573 1.08103 18.7406 0.963332 18.509C0.801959 18.1914 0.887649 17.7785 1.15491 17.5867Z",
    fill: "#9DE5F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2918 9.92808C10.592 10.4752 10.5793 10.8569 10.5793 11.5187C10.5793 11.7604 10.4521 12.0403 9.82858 12.0403C9.30683 12.0403 9.12875 11.8495 9.12875 11.1878C9.12875 10.0936 9.61225 9.57183 9.98125 9.25375C10.4012 8.89742 11.1137 8.50297 11.1137 7.8159C11.1137 7.23058 10.6047 6.95062 9.9685 6.95062C8.67058 6.95062 8.95058 7.93039 8.26344 7.93039C7.91988 7.93039 7.5 7.70137 7.5 7.20508C7.5 6.51797 8.28887 5.5 10.0067 5.5C11.6354 5.5 12.7169 6.4034 12.7169 7.59949C12.7169 8.79562 11.6354 9.66083 11.2918 9.92808ZM10.8211 13.8981C10.8211 14.4197 10.3884 14.8777 9.84133 14.8777C9.29417 14.8777 8.87425 14.4197 8.87425 13.8981C8.87425 13.3637 9.30692 12.9183 9.84133 12.9183C10.3757 12.9183 10.8211 13.3637 10.8211 13.8981Z",
    fill: "#2FA7CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.f7658cb21a141cb3180cff4ce1c9fc15.svg";
export { ForwardRef as ReactComponent };